import { TECHNICAL_FILTER_QUERY_KEYS } from './technicalFilters.js'

const FILTER_KEYS = [
  'filters',
  'categories',
  'brands',
  'reviews',
  'price',
  'sort',
  'search',
  'headlight_types',
  'technologie',
  'type',
  ...TECHNICAL_FILTER_QUERY_KEYS,
]

export function paginationPage(query) {
  const page = parseInt(query?.page, 10)
  return Number.isInteger(page) && page > 1 ? page : null
}

export function hasListFilters(query) {
  return FILTER_KEYS.some(key => !!query?.[key])
}

export function pageQuerySuffix(query) {
  const page = paginationPage(query)
  return page && !hasListFilters(query) ? `?page=${page}` : ''
}

export function paginatedCanonical(baseUrl, query) {
  return baseUrl + pageQuerySuffix(query)
}

export function withPageSuffix(text, query, t) {
  const page = paginationPage(query)
  if (!page || !text) return text
  return `${text} - ${t('utils.paginationSeo.pageTitleSuffix', { page })}`
}

export function paginatedTitle(title, query, t) {
  return withPageSuffix(title, query, t)
}

export function withPageQuery(links, query) {
  const suffix = pageQuerySuffix(query)
  if (!suffix) return links
  return links.map(link => ({ ...link, href: link.href + suffix }))
}
